// Derives a display-friendly name from an email's local-part, e.g.
// "john.smith@school.com" -> "John Smith". Used as a navbar fallback
// only when the account has no stored name.
export function deriveNameFromEmail(email) {
  if (!email) return '';
  const local = email.split('@')[0];
  if (!local) return '';
  return local
    .replace(/[._-]+/g, ' ')
    .trim()
    .split(' ')
    .filter(Boolean)
    .map(w => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}
